/**
 * @module websocket.event.handlers.pilots.pilot-deleted
 */
import { store } from '../../../../state/store'
import { setPilotListUpdated } from '../../../../state/websocket.slice'

export default function handlePilotDeleted(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handlePilotDeleted', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setPilotListUpdated(data))
  }
} 